import React from "react";

type PageHeaderParams = {
    title: string
}

const PageHeader = ({title}: PageHeaderParams) => {

    return (
        <div className="flex items-center justify-between py-5 lg:py-6">
            <div className="flex items-center space-x-1">
                <h2 className="line-clamp-1 text-xl font-medium text-slate-700 dark:text-navy-50 lg:text-2xl">
                    {title}
                </h2>
            </div>
        </div>
    )

}

export default PageHeader;
